<template>
  <div v-if="offers.length" class="flex gap-1">
    <div
      class="mb-1 px-4 flex items-center w-fit-content rounded"
      :class="
        offer.offerColor && offer.offerColor.value
          ? `offer--${offer.offerColor.value}`
          : 'offer--purplePrimary'
      "
      v-for="(offer, index) in offers.slice(0, 1)"
      :key="index"
    >
      <span>{{ offer.tag }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["offers"]),
  },
};
</script>
